import React from 'react';

import { AtsType } from 'src/generated/mloop-graphql';

import { getAtsService, useOrgAtsService } from 'src/hooks/atsService';

type Props = {
  atsType?: AtsType;
};

const AtsName = ({ atsType }: Props) => {
  const currentAtsService = useOrgAtsService();

  // If an ATS Type is provided, use that
  if (atsType) {
    return <>{getAtsService(atsType).name}</>;
  }
  // If org is connected to an ATS, use that
  if (currentAtsService) {
    return <>{currentAtsService.name}</>;
  }
  return <>ATS</>;
};

export default AtsName;
